// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3_mx-","disabled":"FileBtn_disabled__2eYih","warn":"FileBtn_warn__32ttz","fade":"FileBtn_fade__3tC7W"};